import React from "react";
import { Box, Typography, Button, Dialog, DialogContent } from "@mui/material";

interface TutorialOverlayProps {
  open: boolean;
  onComplete: () => void;
  onSkip: () => void;
}

const TutorialOverlay: React.FC<TutorialOverlayProps> = ({
  open,
  onComplete,
  onSkip,
}) => {
  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: "#2d2d2d",
          color: "white",
          borderRadius: 3,
          border: "2px solid #3498db",
        },
      }}
    >
      <DialogContent sx={{ p: 4, textAlign: "center" }}>
        <Typography
          variant="h5"
          component="h2"
          gutterBottom
          sx={{ color: "#3498db", mb: 3 }}
        >
          How to Play
        </Typography>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ color: "#3498db", mb: 2 }}>
            🐱 Step 1: Select a Cat
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            Click on any cat to select it.
          </Typography>

          <Typography variant="h6" sx={{ color: "#3498db", mb: 2 }}>
            💰 Step 2: Transfer Kibbles
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            Click on a second cat to give it kibbles from the first one.
          </Typography>
        </Box>

        <Box
          sx={{
            p: 3,
            backgroundColor: "#1a1a1a",
            border: "1px solid #3498db",
            borderRadius: 2,
            mb: 4,
          }}
        >
          <Typography
            variant="body1"
            sx={{ color: "#bdc3c7", fontWeight: "bold", mb: 1 }}
          >
            💡 Tip:
          </Typography>
          <Typography variant="body2" sx={{ color: "#bdc3c7" }}>
            Cats with more kibbles than they need (green) can donate to cats who
            need more kibbles (red).
          </Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
          <Button
            variant="contained"
            onClick={onComplete}
            sx={{
              backgroundColor: "#3498db",
              "&:hover": {
                backgroundColor: "#2980b9",
              },
            }}
          >
            Got it!
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default TutorialOverlay;
